'use client'

import InnerDivider from '../components/InnerDivider'
import Grid from '../components/grid'
import { Map } from '../components/map'
import Container from '../components/ui/container'
import Text from '../components/ui/text'
import { Page, Office } from '@telesoft/types/payload-types'
import React, { ReactElement } from 'react'
import { MdEmail, MdPhone } from 'react-icons/md'

export type OfficeProps = Extract<Page['blocks'][0], { blockType: 'offices-list' }>

export default function OfficesList(block: OfficeProps): ReactElement {
  const offices = block.office as Office[]
  const sortedOffices = offices.sort((a, b) => a.order - b.order)

  return (
    <Container>
      {sortedOffices?.map((office: Office) => {
        const latitude = office.address.coordinates.latitude
        const longitude = office.address.coordinates.longitude
        return (
          <Grid key={office.id} className="mb-8 gap-0 md:gap-8">
            <div className="bg-accent-1 col-span-full p-6 text-black md:col-span-4 md:p-12 lg:col-span-7 lg:p-20">
              <Text variant="mediumHeading" className="">
                {office.title}
              </Text>

              <InnerDivider />

              <Text variant="body" className="font-bold">
                {office.company}
              </Text>
              <Text className="text-black">
                {office.address.addressOne} <br />
                {office.address.addressTwo} <br />
                {office.address.town} <br />
                {office.address.postcode} <br />
                {office.address.country}
              </Text>

              <div className="my-4 md:my-6 lg:my-8" />

              {office.contacts?.map((contact: any, idx: number) => {
                return (
                  <div key={idx} className="flex items-center justify-start">
                    <a href={`mailto:${contact.value}`} target="_blank">
                      <Text className="border-telesoft flex items-center justify-start border-b font-medium">
                        {contact.type === 'email' && (
                          <>
                            <MdEmail className="mr-2 text-black" />
                            <span>{contact.label}</span>
                          </>
                        )}
                        {contact.type === 'phone' && (
                          <>
                            <MdPhone className="mr-2 text-black" />
                            <span>{contact.label}</span>
                          </>
                        )}
                      </Text>
                    </a>
                  </div>
                )
              })}
            </div>

            <div className="relative z-0 col-span-full min-h-[280px] select-none overflow-hidden bg-black md:col-span-4 lg:col-span-5">
              <Map center={[latitude, longitude]} popupText={office.title} />
            </div>
          </Grid>
        )
      })}
    </Container>
  )
}
